import { useEffect, useState } from "react";
import { CustomerMetafields } from "~/types"
import { brochureWishlistCookie, isBrochure, isKiosk, routeWishList, wishlistButtonNextTitle } from "../settings/__product";
import { ShowMaximizeHeader, header } from "../settings";
import Logo from "~/assets/icons/Logo";
import WishButtonIcon from "../custom_icons/WishButtonIcon";
import Maximize from "~/rs-components/Maximize.client";
import Navigation from "~/rs-components/global/navigation/Navigation.client";
import SearIcon from "~/assets/icons/SearchIcon";

type SetupDesktopHeaderProps = {
    setShowCategory: React.Dispatch<React.SetStateAction<string | boolean>>,
    openCart: () => void,
    menuItems: any[]
    showCategory: string | boolean,
    shopSettings: string,
    customer?: CustomerMetafields,
}

export default function SetupDesktopHeader({ setShowCategory, openCart, showCategory, menuItems, shopSettings, customer }: SetupDesktopHeaderProps) {

    const [wishlistCount, setWishlistCount] = useState(0);

    useEffect(() => {
            const wishlist = getWishlistCount();
            setWishlistCount(wishlist.length);
        
            const handleWishlistUpdate = (event: Event) => {
                const customEvent = event as CustomEvent;
                setWishlistCount(customEvent.detail);
            };
        
            window.addEventListener('wishlistUpdated', handleWishlistUpdate);
        
            return () => {
                window.removeEventListener('wishlistUpdated', handleWishlistUpdate);
            };
    }, []);

    const getWishlistCount = () => {
        const cookies = document.cookie.split(';');
        for (const cookie of cookies) {
            const [cookieName, cookieValue] = cookie.trim().split('=');
            if (cookieName === brochureWishlistCookie.WISHLIST_COOKIE_NAME) {
                return JSON.parse(decodeURIComponent(cookieValue));
            }
        }
        return [];
    };
    
    const hideBrandsKiosk: boolean = header.hiddenBrand;
    const hiddenProductRanges: boolean = header.hiddenProductRanges;
    return (
        <>
            <div onMouseLeave={() => setShowCategory(false)} className="hidden lg:block top-0 z-50">
                <div className="headerKiosk flex flex-row items-center px-8" onMouseEnter={() => setShowCategory(false)}>
                    {/* TODO: move image in assets image */}
                    <div className="basis-3/12">
                        <a className="aLogo" href="/">
                            <Logo />
                        </a>
                    </div>
                    <div className="logo basis-6/12 text-center">
                        {!hideBrandsKiosk && <a href="/brands" className="menu">Brands</a>}
                        {!hiddenProductRanges && <a href="/product-ranges" className="menu">Product Ranges</a>}
                        <a href="/products"><span className="menu">All Products</span></a>
                        <a className="btn-contacts" href="/contacts"><span>Contacts</span></a>
                    </div>
                    <div className="topUserArea loginCart basis-3/12 text-right">
                        <div className="topUserArea__search-container">
                            <div className="topUserArea__search">
                                <form action={`/products`} method="GET">
                                    <input name="search" type="search" placeholder="Search..." />
                                    <i className="fa fa-search">
                                        <button type='submit' className='buttonSearch'><SearIcon /></button>
                                    </i>
                                </form>
                            </div>
                        </div>
                        {wishlistButtonNextTitle &&
                            <div className={`topUserArea__login ${isBrochure ? 'brochure' : ''} ${wishlistCount > 0 ? '' : 'empty'}`}>
                                <a href={routeWishList}>
                                    <WishButtonIcon />
                                    {isBrochure && (
                                        wishlistCount > 0 && (<p className="wishlist-counter">{wishlistCount}</p>)
                                    )}
                                </a>
                            </div>
                        }
                       {ShowMaximizeHeader &&
                            <div className="maximize-div">
                                <Maximize />
                            </div>
                        }
                    </div>
                </div>
                <Navigation css={""} menuItems={menuItems} showCategory={showCategory} setShowCategory={setShowCategory} shopSettings={shopSettings} />
            </div>
        </>
    )
}